// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1rsjy","footer":"Form_footer__3NB9B"};